module.exports = __webpack_public_path__ + "img/coco-club-thumb.eeeef34a.jpg";